<template>
  <ai-events
    v-if="Array.isArray(entertainments) && entertainments.length"
    :title="title"
    :entertainments="entertainments"
    :location="location" />
</template>

<script setup lang="ts">
import type { HotelEntertainment } from '~~/domains/graphql';

interface HotelEntertainmentsProps {
  title: string;
  location: string;
  entertainments?: HotelEntertainment[];
}
defineProps<HotelEntertainmentsProps>();
</script>
